export const GATES = {
  CARRY_FORWARD: 'carry_forward',
  INSTANT_SURVEY_AUTO_SAVE: 'auto_save_survey',
  INSTANT_SURVEY_MAINTENANCE: 'instant_survey_maintenance',
  MULTI_LEVEL_DISQUALIFY: 'multi_level_disqualify',
  MULTIPLE_SUBSCRIPTIONS_REVAMP: 'multiple_subscriptions_revamp',
  PIPING_RESPONSES: 'piping_responses',
  PREVIEW_SURVEY: 'preview_survey',
  QUESTION_GROUP_BLOCKS: 'question_group_blocks',
  QUESTION_LIBRARY: 'question_library',
  QUESTION_OPTION_LOGIC: 'question_option_logic',
  QUESTION_TYPE_VIDEO: 'video_survey',
  REAL_TIME_SAMPLE_VALIDATION: 'real_time_sample_validation',
  REQUIRE_QUESTION_TYPE_SELECTION: 'require_question_type_selection',
  RESPONSE_QUALITY_TAB: 'response_quality_tab',
  RICH_TEXT_FORMATTING: 'rich_text_formatting',
  SCREENER_QUESTIONS: 'screener_questions',
  SEQUENTIAL_MONADIC: 'sequential_monadic',
  SEQUENTIAL_MONADIC_MODEL_MIGRATION: 'sequential_monadic_model_migration',
  STANDARD_SURVEY: 'standard_survey',
  SURVEY_DASHBOARD_FULL_WIDTH: 'survey_dashboard_full_width',
  SURVEY_DASHBOARD_V2_RESPONSES: 'survey_dashboard_v2_responses',
  SURVEY_INCLUDE_DISQUALIFIED_RESPONSES: 'survey_include_disqualified_responses',
  TURF_SIMULATOR: 'turf_simulator',
  USE_CALYPSO_AS_SURVEY_PROVIDER: 'use_calypso_as_survey_provider',
  VAN_WESTENDORP: 'van_westendorp',
};
